import { ActionCreator } from 'redux';
import { uniqueId } from 'lodash-es';

import { ApplicationState } from '..';
import {
    ShowToastAction,
    HideToastAction,
    SeverityTypes,
    SetToastPortalWrapperAction,
    NotistackMessageParams,
    ToastState,
} from './types';

export const ShowToast: ActionCreator<ShowToastAction> = (params: {
    message: string;
    duration?: number;
    onClose?(): void;
    severity: SeverityTypes;
    width?: string;
    key?: string;
}): ShowToastAction => ({
    type: '@@toast/SHOW',
    payload: {
        notification: {
            message: params.message,
            onClose: params.onClose,
            duration: params.duration,
            severity: params.severity,
            key: params.key || uniqueId('toast-'),
            width: params.width,
        },
    },
});

export const HideToast: ActionCreator<HideToastAction> = (key?: string): HideToastAction => ({
    type: '@@toast/HIDE',
    payload: {
        key,
    },
});

export const SetToastPortalWrapper: ActionCreator<SetToastPortalWrapperAction> = (
    isInsidePortal: boolean
): SetToastPortalWrapperAction => ({
    type: '@@toast/SET_PORTAL_WRAPPER',
    payload: {
        isInsidePortal,
    },
});

export const getToastNotifications = (store: ApplicationState): Array<NotistackMessageParams> =>
    store.toast.notifications;
export const getToastStore = (state: ApplicationState): ToastState => state.toast;
